import React from "react";
import callAPI from "../../../../../api/apiCaller";
import { ButtonSpacer } from "../../../../../common/Button/styles";
import Checkbox from "../../../../../common/Checkbox";
import CheckboxGroup from "../../../../../common/CheckboxGroup";
import Labelize from "../../../../../common/Labelize";
import Modal from "../../../../../common/Modal";
import TextInput from "../../../../../common/TextInput";
import {
  createInitialValid,
  updateValid,
  updateValidTogether,
  validateArray,
  validateIsValid,
  validateString,
  validateText,
  uploadImageToS3,
} from "../../../../../common/utils";
import {
  FileText,
  InputFileUploadContainer,
  LabelButton,
  SendAnnouncementContainer,
  StyledReactQuill,
} from "./styles";
import { Context } from "../../../../../Store";
import Loading from "../../../../../common/Loading";
// ReactQuill css import
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import ImageUpload from "../../../../../common/ImageUpload";
import { Input } from "../../../../../common/TextInput/styles";
import Icon from "../../../../../common/Icon";
const defaultFontSize = "14px";
const modules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ size: ["small", false, "large", "huge"] }], // Adding font size options
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["clean"],
  ],
  clipboard: {
    matchVisual: false,
  },
};

const formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
];

function SendAnnouncement({ announcementProgram, closeModal, announcementId }) {
  const [announcement, setAnnouncement] = React.useState({
    programId: +announcementProgram,
    subject: "",
    content: "",
    // announceTo: [],
    image: "",
  });

  // console.log("Announcement:", announcement);

  const [isValid, setIsValid] = React.useState(
    // createInitialValid(["subject", "content", "announceTo"])
    createInitialValid(["subject"])
  );
  const [isSendingAnnouncement, setIsSendingAnnouncement] =
    React.useState(false);
  const { state, dispatch } = React.useContext(Context);

  React.useEffect(() => {
    if (announcementId) {
      callAPI(dispatch, "getAnnouncement", { id: announcementId }).then(
        (retrievedAnnouncement) => {
          updateValidTogether(isValid, setIsValid, retrievedAnnouncement.data, {
            subject: validateText,
            content: validateText,
            announceTo: validateArray(),
            // image: validateText,
          });
          if (retrievedAnnouncement.isResponseOk) {
            setAnnouncement(retrievedAnnouncement.data);
          } else setAnnouncement({});
        }
      );
    }
  }, []);

  function send() {
    setIsSendingAnnouncement(true);
    if (announcementId) {
      callAPI(dispatch, "saveAnnouncement", {
        id: announcement.id,
        programId: announcement.programId,
        subject: announcement.subject,
        content: announcement.content,
        announceTo: announcement.announceTo,
      }).then(() => {
        setIsSendingAnnouncement(false);
        closeModal(true);
      });
    } else {
      callAPI(dispatch, "sendAnnouncement", { ...announcement }).then(() => {
        setIsSendingAnnouncement(false);
        closeModal(true);
      });
    }
  }

  const Image = (event) => {
    callAPI(dispatch, "signedUrl", {
      fileType: event.target.files[0].type.split("/")[1],
      fileSize: Math.ceil(event.target.files[0].size / (1024 * 1024)),
    }).then((response) => {
      setAnnouncement((prevState) => ({
        ...prevState,
        image: response?.data?.key,
      }));
      return uploadImageToS3(dispatch, "uploadFile", {
        url: response.data.url,
        file: event.target.files[0],
      });
    });
  };

  if (announcementId && announcement.subject === "") {
    return (
      <Modal
        title={announcementId ? "Edit Announcement" : "Send Announcement"}
        isDelete={true}
        onClose={() => {
          closeModal(false);
        }}
        actions={[
          {
            text: "Cancel",
            onClick: () => {
              closeModal(false);
            },
          },
        ]}
      >
        <SendAnnouncementContainer>
          <Loading loadingItem="Announcement" />
        </SendAnnouncementContainer>
      </Modal>
    );
  }
  return (
    <Modal
      title={announcementId ? "Edit Announcement" : "Send Announcement"}
      isDelete={true}
      isModalStyle={true}
      isHideIcon={true}
      isButtonCenter={true}
      isLogin={true}
      maxWidth={"767px"}
      onClose={() => {
        closeModal(false);
      }}
      actions={[
        {
          text: "Cancel",
          onClick: () => {
            closeModal(false);
          },
        },
        {
          text: "Publish",
          disabled:
            !validateIsValid(isValid) ||
            // !announcement?.image ||
            !announcement.content?.length,
          variant: "primary",
          icon: isSendingAnnouncement ? "loading" : "send",
          onClick: () => {
            send();
          },
        },
      ]}
    >
      <SendAnnouncementContainer>
        <Labelize modalStyleLabel label="Subject">
          <TextInput
            modalStyleInput
            maxWidth={"100%"}
            value={announcement.subject}
            setValue={(newValue) => {
              setAnnouncement({
                ...announcement,
                subject: newValue,
              });
            }}
            isValid={isValid.subject}
            validator={validateString}
            setIsValid={updateValid(isValid, setIsValid, "subject")}
            placeholder="Announcement Subject"
          />
        </Labelize>
        <ButtonSpacer />
        {/* <Labelize label="Body">
          <TextInput
            value={announcement.content}
            isTextArea
            isHeight={true}
            setValue={(newValue) => {
              setAnnouncement({
                ...announcement,
                content: newValue,
              });
            }}
            placeholder="Announcement Body"
            // wordLimit={250} 
            isValid={isValid.content}
            validator={validateString}
            setIsValid={updateValid(isValid, setIsValid, "content")}
          />
          
        </Labelize> */}
        {/* using rtc pkgs*/}
        <Labelize modalStyleLabel label="Body">
          <StyledReactQuill
            value={announcement.content}
            onChange={(newValue) => {
              setAnnouncement({
                ...announcement,
                content: newValue,
              });
            }}
            placeholder="Announcement Body"
            style={{ fontSize: defaultFontSize }}
            modules={modules}
            formats={formats}
          />
        </Labelize>

        <ButtonSpacer />
        <Labelize modalStyleLabel label="Upload Image">
          <InputFileUploadContainer>
            <FileText>
              {announcement?.image
                ? announcement?.image
                : "png and jpg image only"}
            </FileText>
            <LabelButton>
              <Icon type="uploadIcon" />
              Choose File
              <Input
                type="file"
                onChange={(e) => Image(e)}
                hidden
                accept=".png, .jpg, .jpeg"
              />
            </LabelButton>
          </InputFileUploadContainer>
        </Labelize>

        <ButtonSpacer />

        {/* <CheckboxGroup
          label={"Announce To"}
          value={announcement.announceTo}
          setValue={(newValue) => {
            setAnnouncement({
              ...announcement,
              announceTo: newValue,
            });
          }}
          isValid={isValid.announceTo}
          setIsValid={updateValid(isValid, setIsValid, "announceTo")}
          options={[
            {
              label: "Mentors",
              value: "mentor",
            },
            {
              label: "Mentees",
              value: "mentee",
            },
            {
              label: "Program Managers",
              value: "manager",
            },
          ]}
        /> */}
      </SendAnnouncementContainer>
    </Modal>
  );
}
export default SendAnnouncement;
